import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { NavigationUrl } from '../../../constant/navigation-url';
import { HeaderService } from './header.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import sessionStorageUtility from '../../../common/utils/sessionStorage';
import { SnackBarService } from '../../services/snackbar.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    providers: [HeaderService],
})
export class HeaderComponent {
    @Input() showResponsive!: boolean;
    @Input() isExpanded!: boolean;
    @Output() responsiveFlag = new EventEmitter();
    @Output() expandedFlag = new EventEmitter();
    isOpen = false;
    selectDropdownList = [
        { key: 1, value: 'Manage' },
        { key: 2, value: 'Monitor' },
        { key: 3, value: 'Maintain' },
    ];

    constructor(
        private breakpointObserver: BreakpointObserver,
        public modalService: NgbModal,
        private router: Router,
        private headerService: HeaderService,
        public jwtHelper: JwtHelperService,
        private snackbarService: SnackBarService
    ) {}

    sideNav() {
        this.breakpointObserver.observe(['(min-width: 0) and (max-width: 767px)']).subscribe((result: BreakpointState) => {
            if (result.matches) {
                this.showResponsive = true;
            }
        });
        this.breakpointObserver.observe(['(min-width: 768px) and (max-width: 991px)']).subscribe((result: BreakpointState) => {
            if (result.matches && !this.isExpanded) {
                this.showResponsive = true;
            }
            if (result.matches && this.isExpanded) {
                this.showResponsive = false;
            }
        });
        this.breakpointObserver.observe(['(min-width: 992px)']).subscribe((result: BreakpointState) => {
            if (result.matches && !this.isExpanded) {
                this.showResponsive = true;
            }
            if (result.matches && this.isExpanded) {
                this.showResponsive = false;
            }
        });
        this.isExpanded = !this.isExpanded;
        this.responsiveFlag.emit(this.showResponsive);
        this.expandedFlag.emit(this.isExpanded);
    }

    onLogout() {
        const accessToken = sessionStorageUtility.getAccessToken() as string;
        if (this.jwtHelper.isTokenExpired(accessToken)) {
            this.operationAfterLogout('You have successfully logged out.');
        }
        this.headerService.logoutApi().then(response => {
            if (response.hasError) {
                this.snackbarService.errorSnackBar(response.message);
                return;
            }
            this.operationAfterLogout('You have successfully logged out.');
        });
    }

    operationAfterLogout(message: string) {
        // const theme = LocalStorageUtility.getTheme() as string;
        // LocalStorageUtility.setTheme(theme);
        sessionStorage.clear();
        this.router.navigate([NavigationUrl.LOGIN]);
        this.snackbarService.successSnackBar(message);
    }

    gotoDashboard() {
        this.router.navigate([NavigationUrl.DASHBOARD]);
    }
}
